const PAYMENT_ORIGINS = {
  NOTE: "NOTA",
  BANAMEX: "BANAMEX",
  PAYMENT_LINK: "LIGA DE PAGO",
  TRANSFER: "TRANSFERENCIA",
  CASH: "EFECTIVO",
  REFERENCE: "REFERENCIA BANCARIA",
  DEBIT_CARD: "TARJETA DE DÉBITO",
  CREDIT_CARD: "TARJETA DE CRÉDITO",
  BANK_CHECK: "CHEQUE",
  CANCELED: "CANCELADO"
}

export const normalizedPayment = payments => {
  if (Array.isArray(payments)) {
    const newPayments = payments.map(payment => {
      let newPayment = { ...payment };

      if (Number(payment.amount) >= 0) {
        newPayment.debit = payment.amount;
      } else {
        newPayment.payment = payment.amount;
      }
      newPayment.source = PAYMENT_ORIGINS[payment.source]

      return newPayment;
    });
    return newPayments;
  }
  return [];
};
